// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SoEnFaWJ_KTA_j {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.KFMwPOjUSHR87q {
  min-width: 584px;
  min-height: 283px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardDetailLoading": `SoEnFaWJ_KTA_j`,
	"cardBackRedesign": `KFMwPOjUSHR87q`
};
export default ___CSS_LOADER_EXPORT___;
